/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_My_DayInputs */

const cs_nav_section_my_day = /** @type {(inputs: Nav_Section_My_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Můj den`)
};

const en_nav_section_my_day = /** @type {(inputs: Nav_Section_My_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Day`)
};

/**
* | output |
* | --- |
* | "My Day" |
*
* @param {Nav_Section_My_DayInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_my_day = /** @type {((inputs?: Nav_Section_My_DayInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_My_DayInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_section_my_day(inputs)
	return cs_nav_section_my_day(inputs)
});